import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { api, setToken, formatApiError } from "../lib/api";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      const { data } = await api.post("/auth/login", { username, password });
      setToken(data.token);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "Could not sign you in.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[color:var(--paper)] px-6 paper-grain" data-testid="admin-login-page">
      <div className="w-full max-w-sm border border-[color:var(--rule)] bg-[color:var(--paper)] p-9">
        <div className="flex items-center gap-3 text-[color:var(--moss)]">
          <Lock className="w-5 h-5" />
          <p className="eyebrow !text-[color:var(--moss)]">Host access</p>
        </div>
        <h1 className="font-display text-4xl mt-4 leading-tight">Welcome back, Andrea.</h1>
        <p className="font-body text-[color:var(--ink-2)] mt-2">Sign in to manage guest keepsakes.</p>

        <form onSubmit={submit} className="mt-8 space-y-6">
          <div>
            <label className="letter-label" htmlFor="username">Username</label>
            <input
              id="username"
              className="letter-input"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoComplete="username"
              data-testid="login-username"
              required
            />
          </div>
          <div>
            <label className="letter-label" htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              className="letter-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              data-testid="login-password"
              required
            />
          </div>

          {error && (
            <p className="font-body text-sm text-[#a13a2a]" data-testid="login-error">{error}</p>
          )}

          <button type="submit" className="btn-primary w-full" disabled={busy} data-testid="login-submit">
            {busy ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
